import DOMPurify from "dompurify";

// Sanitise admin-authored HTML (guides, legal pages, rich-text editor) before
// rendering, as defence-in-depth against stored XSS. Links may open in a new
// tab, so target/rel are preserved.
export const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html || "", { ADD_ATTR: ["target", "rel"] });
